import { reduxForm } from 'redux-form';
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

class errorPage404Public extends Component {

  render() {
    return (
        <div className="hgt100">
          <div className="errorwrap">
            <div className="errorblock">
                <div className="errorbox">
                    <h3 className="title-404">4<i className="fa fa-frown-o" aria-hidden="true"></i>4</h3>
                    <h4>OOPS!</h4>
                    <p>The page you are looking for is not available.</p>
                </div>
            </div>
          </div>
          <NavLink className="gobackbtn" exact to='/login'>GO BACK TO DASHBOARD</NavLink>
        </div>
    );
  }
}

errorPage404Public = reduxForm({
  form: 'errorPage404Form',
  enableReinitialize: true, // this is needed!!
})(errorPage404Public);

export default errorPage404Public;



// WEBPACK FOOTER //
// ./src/containers/errorPage404Public.js